import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setData, setDrawerAlert } from 'slices/drawer'
import { faqService, parameterService } from 'services'
import { FAQ_STAGES, ORIGIN, PARAMETERS_CODE } from 'app-constants'
import { FaqInitial, FaqCategory, FaqSearch } from './components'
import { GET_FAQ_ERROR_MESSAGE } from './constants'

export function FaqDrawer() {
  const [faq, setFaq] = useState([])
  const [category, setCategory] = useState('')
  const [isFeedbackEnabled, setIsFeedbackEnabled] = useState(null)
  const { stage, data: drawerData } = useSelector(({ drawer }) => drawer)
  const dispatch = useDispatch()
  const { getFaqs } = faqService()
  const { getParameter } = parameterService()
  const { [PARAMETERS_CODE.ENABLE_SEARCH_FAQ_AI]: isFaqSearchEnabled } = useSelector(
    ({ parameters }) => parameters
  )

  useEffect(() => {
    async function getIsFeedbackEnabled() {
      try {
        const { data } = await getParameter(PARAMETERS_CODE.FAQ_TEXT_FEEDBACK_PARAMETER_CODE)

        setIsFeedbackEnabled(data.active)
      } catch (error) {
        console.error(error)

        setIsFeedbackEnabled(false)
      }
    }

    if (isFeedbackEnabled === null) getIsFeedbackEnabled()
  }, [isFeedbackEnabled])

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await getFaqs({ brand: ORIGIN })
        setFaq(data)
      } catch (error) {
        const errorMessage = error?.response?.data?.message || GET_FAQ_ERROR_MESSAGE

        console.error(error)
        dispatch(setDrawerAlert({ severity: 'error', title: errorMessage }))
      }
    }

    const hasFaqs = faq.length
    if (!hasFaqs) fetchData()
  }, [dispatch, faq])

  useEffect(() => {
    function handleInitialCategory() {
      const { faqInitialCategory } = drawerData

      if (faqInitialCategory) {
        setCategory(faqInitialCategory)
        dispatch(setData({}))
      }
    }

    handleInitialCategory()
  }, [drawerData, dispatch])

  return stages({ faq, setFaq, category, setCategory, isFeedbackEnabled, isFaqSearchEnabled })[
    stage
  ]
}

function stages({ isFaqSearchEnabled, ...props }) {
  return {
    [FAQ_STAGES.INITIAL]: isFaqSearchEnabled ? <FaqSearch {...props} /> : <FaqInitial {...props} />,
    [FAQ_STAGES.CATEGORY]: <FaqCategory {...props} />,
  }
}
